import { IEnvironment } from "src/app/core/models/environment.interface";

export const environment: IEnvironment = {
  production: false,
  loginUrl: 'https://dev-auth.healthexam.ai',
  remitAppUrl: 'https://wa-remit-v2-d-f32c1665b95c.herokuapp.com',
  adminAppUrl: 'https://dev-admin.healthexam.com',
  phiAppUrl: 'https://dev-patients.healthexam.com',
  studiesAppUrl: 'https://dev-studies.healthexam.com',
  healthPayAppUrl: 'https://id-preview--4cbbc3f9-d56c-46ff-bdb9-a4b05c022dfa.lovable.app/',
  threadsAppUrl: 'https://id-preview--d8f36b74-92af-4ea3-986f-5982b3d1c6b8.lovable.app/',
  automateAppUrl:
    'https://id-preview--81eec655-e426-455e-a23a-0ff80984e7c4.lovable.app/',
  custodianAppUrl:
    'https://id-preview--88d8aad4-82d0-4bc1-a2a3-9c50a3d50199.lovable.app/',
  engageAppUrl: 'https://dev-engage.healthexam.com',
  billerAppUrl: 'https://dev-biller.healthexam.com',
  chartsAppUrl: 'https://dev-charts.healthexam.com',
  chartsV2AppUrl: 'https://dev-chartsv2.healthexam.com',
  clinicV3AppUrl: 'https://dev-clinic.healthexam.com',
  apiBaseUrl: 'https://as-phi-v2-d-e036136e9efe.herokuapp.com/', // Also used for chat API: /api/v1/chat/*
  adminApiBaseUrl: 'https://as-account-v2-d-90167a8f915a.herokuapp.com/',
  billerApiBaseUrl: 'https://as-biller-v2-d-6639a0a9ef39.herokuapp.com/',
  aiApiUrl: 'https://as-ai-v2-d-4bd546c768f5.herokuapp.com/',
  engageApiBaseUrl: 'https://as-engage-v2-d-47a313d8c8c4.herokuapp.com/',
  engageSocketUrl: 'https://as-engage-v2-d-47a313d8c8c4.herokuapp.com',
  phiChartsBaseUrl: 'https://as-phi-v2-p-d711a3986431.herokuapp.com/',
  signatureKey: 'heathexamplatform@lo!@0oa8zj*4j8y=tx*6t$ytx-4=nqne8pbi8_tiv9l(8jaf(',
  worksheetViewsRestSyncEnabled: true,
  worksheetWorklistsRestSyncEnabled: true,
  worksheetReferralsViewCountsRestEnabled: true,
  seedEngageMedicationsDemo: false,
  seedEngagePreferredPharmacyDemo: false,
  seedEngageProspectOverviewDemo: false,
  preferredClinicCompanyId: '27a8906a-a8ab-415f-9128-029901816b8e',
  authAppUrl: 'https://dev-auth.healthexam.ai',
  ayaApiBaseUrl: 'https://dev-aya.healthexam.ai/api/aya',
  ayaAppUrl: 'https://id-preview--ad5b0495-bbf4-49ca-8dce-8544734ccca6.lovable.app',
  ayaHealthChatAppUrl: 'https://dev-www.healthexam.com',
}
